import React from "react";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";

// Create custom vehicle icon
// Create custom red pin icon with count
const createVehicleIcon = (count = 1) => {
  const svg = `
    <svg width="40" height="56" viewBox="0 0 40 56" xmlns="http://www.w3.org/2000/svg">
      <!-- Red pin shape - narrower point -->
      <path d="M 20 0 C 10 0 2 8 2 18 C 2 32 20 56 20 56 C 20 56 38 32 38 18 C 38 8 30 0 20 0 Z" fill="#dc1519" stroke="#af1e1e" stroke-width="2"/>      

      <!-- White circle -->
      <circle cx="20" cy="18" r="12" fill="white"/>

      <!-- Count number -->
      <text x="20" y="22" font-size="14" font-weight="bold" text-anchor="middle" fill="#ed4949" font-family="Arial, sans-serif">
        ${count > 99 ? "99+" : count}
      </text>
    </svg>
  `;

  return L.divIcon({
    html: svg,
    className: "",
    iconSize: [40, 56],
    iconAnchor: [20, 56],
    popupAnchor: [0, -56],
  });
};
export default function ALPRMarkers({ markers, onMarkerClick }) {
  if (!markers || markers.length === 0) return null;

  // Group markers by location (latitude, longitude)
  const groupedMarkers = markers.reduce((acc, marker) => {
    const key = `${marker.system_latitude}_${marker.system_longitude}`;
    if (!acc[key]) {
      acc[key] = {
        ...marker,
        count: 0,
        detections: [],
      };
    }
    acc[key].count++;
    acc[key].detections.push(marker);
    return acc;
  }, {});

  return (
    <>
      {Object.values(groupedMarkers).map((locationGroup, index) => {
        const lat = parseFloat(locationGroup.system_latitude);
        const lng = parseFloat(locationGroup.system_longitude);

        if (isNaN(lat) || isNaN(lng)) return null;

        const icon = createVehicleIcon(locationGroup.count);

        return (
          <Marker
            key={`${locationGroup.system_latitude}_${locationGroup.system_longitude}_${index}`}
            position={[lat, lng]}
            icon={icon}
            // eventHandlers={{
            //   click: () => onMarkerClick(locationGroup.detections[0]),
            // }}
          >
            <Popup>
              <div className="text-sm">
                <p className="font-semibold">
                  {locationGroup.count} detection
                  {locationGroup.count !== 1 ? "s" : ""}
                </p>
                <p className="text-xs text-gray-600">
                  {locationGroup.detections[0].license_plate_number}
                </p>
                <p className="text-xs">
                  {locationGroup.system_latitude}, {locationGroup.system_longitude}
                </p>
              </div>
            </Popup>
          </Marker>
        );
      })}
    </>
  );
}
